import { combineEpics } from 'redux-observable';

import { addressResolvedEpic } from './address-resolved.epic';
import { lookupAddressEpic } from './addressLookup.epic';
import { resolveAddressEpic } from './resolve-address.epic';

const addressVerificationEpic = combineEpics(lookupAddressEpic, resolveAddressEpic, addressResolvedEpic);

export { addressVerificationEpic };
